// extracted by mini-css-extract-plugin
module.exports = {"Logo":"VisgRB"};